import { useState } from "react";
import { Col, useIsMobile } from "./Flexbox";
import Text from "./Text";
import Spinner from "./Spinner";

const HIDE_SCROLLBAR = 'roles-table-no-scrollbar';
const COLUMNS = [
    {key: 'nombre', label: 'Nombre', width: {flex: '3 1 300px', minWidth: '200px'}},
    {key: 'usuarios', label: 'Usuarios', width: {flex: '1 1 120px', minWidth: '100px'}}
];
const ACTION_WIDTH = {flex: '0 0 90px', minWidth: '90px'};

const RolesTable = props => {
    const isMobile = useIsMobile();
    const [hoveredRow, setHoveredRow] = useState(null);
    const isDark = props.theme.White !== "#FFFFFF";
    const rowColor = isDark ? props.theme.Ey : props.theme.Ed;
    const hoverColor = isDark ? props.theme.FOURFOUR : props.theme.Ey;

    const styles = {
        row: {
            display: 'flex', width: '100%', height: '38px', alignItems: 'center', boxSizing: 'border-box',
            border: `0.5px solid ${props.theme.Ey}`, borderRadius: '4px', backgroundColor: rowColor
        },
        col: (width) => ({
            ...width, display: 'flex', alignItems: 'center', boxSizing: 'border-box', padding: '0 16px'
        }),
        truncate: {
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%'
        }
    }

    return (
        <div className={isMobile ? HIDE_SCROLLBAR : undefined} style={{width: '100%', flex: 1, minHeight: 0, overflowX: 'auto', overflowY: 'auto', marginTop: 10}}>
            <style>{`.${HIDE_SCROLLBAR}::-webkit-scrollbar { display: none; }`}</style>
            <div style={{minWidth: 'min-content', maxWidth: '100%'}}>
                <div style={{position: 'sticky', top: 0, zIndex: 1, backgroundColor: rowColor}}>
                    <div style={styles.row}>
                        {COLUMNS.map(col => (
                            <div key={col.key} onClick={() => props.requestSort(col.key)} style={{...styles.col(col.width), height: '36px', cursor: 'pointer', userSelect: 'none'}}>
                                <Text size={15} weight="medium" color={props.theme.ONED}>{col.label}</Text>
                                <Text size={12} style={{marginLeft: '4px'}}>{props.getIcon(col.key)}</Text>
                            </div>
                        ))}
                        <div style={styles.col(ACTION_WIDTH)}/>
                    </div>
                </div>
                {props.isLoading ? (
                    <Col style={{justifyContent: 'center', alignItems: 'center', minHeight: 200, width: '100%'}}>
                        <Spinner theme={props.theme}/>
                    </Col>
                ) : props.roles.map((role, index) => {
                    const rowKey = role.key || index;
                    return (
                        <div key={rowKey} onMouseEnter={() => setHoveredRow(rowKey)} onMouseLeave={() => setHoveredRow(null)} style={{...styles.row, backgroundColor: hoveredRow === rowKey ? hoverColor : rowColor}}>
                            <div style={styles.col(COLUMNS[0].width)} title={role.nombre}>
                                <Text size={15} color={props.theme.ONED} style={styles.truncate}>{role.nombre}</Text>
                            </div>
                            <div style={styles.col(COLUMNS[1].width)}>
                                <Text size={15} color={props.theme.SEVENB} style={styles.truncate}>{role.usuarios}</Text>
                            </div>
                            <div style={{...styles.col(ACTION_WIDTH), justifyContent: 'flex-end'}}>
                                {role.isEditable && (
                                    <Text style={{cursor: 'pointer', transition: 'transform 2s ease'}} size={15} onClick={() => props.onEdit(role)} color={props.theme.SEVENB}>Editar</Text>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default RolesTable;